import { AuthType, SwitchingStoreRefType } from 'types/auth'
import { FirebaseDocRefType } from 'firebase/index'
import { MailType, StaffPushSettingType } from 'types/staff'
import { StockUnionType } from 'types/stock'

export const FETCH_EVENT_REFS = 'FETCH_EVENT_REFS'
export const fetchAttendingEventRefsAction = (eventRefs: FirebaseDocRefType[]) => {
  return {
    type: 'FETCH_EVENT_REFS',
    payload: eventRefs,
  }
}

export const FETCH_SWITCHING_STORE_REFS = 'FETCH_SWITCHING_STORE_REFS'
export const fetchSwitchingStoreRefsAction = (switchingStoreRefs: SwitchingStoreRefType[]) => {
  return {
    type: 'FETCH_SWITCHING_STORE_REFS',
    payload: switchingStoreRefs,
  }
}

export const SELECT_TOP_TAB = 'SELECT_TOP_TAB'
export const selectTopTabAction = (nextTab: 'hand_over' | 'delivery') => {
  return {
    type: 'SELECT_TOP_TAB',
    payload: nextTab,
  }
}

export const SELECT_DEFAULT_BREAD_TYPES = 'SELECT_DEFAULT_BREAD_TYPES'
export const selectDefaultBreadTypesAction = (defaultBreadTypes: StockUnionType[]) => {
  return {
    type: 'SELECT_DEFAULT_BREAD_TYPES',
    payload: defaultBreadTypes,
  }
}

export const SIGN_IN = 'SIGN_IN'
export const signInAction = (auth: AuthType) => {
  return {
    type: 'SIGN_IN',
    payload: auth,
  }
}

export const SIGN_OUT = 'SIGN_OUT'
export const signOutAction = () => {
  return {
    type: 'SIGN_OUT',
    payload: null,
  }
}

export const SWITCH_STORE = 'SWITCH_STORE'
export const switchStoreRefAction = (payload: {
  role: number
  brandRef: FirebaseDocRefType | undefined
  storeRef: FirebaseDocRefType | undefined
  shopRef: FirebaseDocRefType | undefined
}) => {
  return {
    type: 'SWITCH_STORE',
    payload: {
      role: payload.role,
      brand_ref: payload.brandRef,
      store_ref: payload.storeRef,
      shop_ref: payload.shopRef,
    },
  }
}

export const SWITCH_BACK_TO_ADMIN = 'SWITCH_BACK_TO_ADMIN'
export const switchBackToAdminAction = () => {
  return {
    type: 'SWITCH_BACK_TO_ADMIN',
    payload: {
      is_event_staff: false,
      is_viewing_event: false,
      manufacturer_ref: undefined,
      role: 0,
      shop_ref: undefined,
      store_ref: undefined,
      switching_store_refs: [],
    },
  }
}

export const TOGGLE_MAILS = 'TOGGLE_MAILS'
export const toggleMailsAction = (mails: MailType[]) => {
  return {
    type: 'TOGGLE_MAILS',
    payload: {
      mails: mails,
    },
  }
}

export const TOGGLE_PUSH_SETTINGS = 'TOGGLE_PUSH_SETTINGS'
export const togglePushSettingsAction = (push_settings: StaffPushSettingType[]) => {
  return {
    type: 'TOGGLE_PUSH_SETTINGS',
    payload: {
      push_settings: push_settings,
    },
  }
}

export const UPDATE_AUTH_BRAND_REF = 'UPDATE_AUTH_BRAND_REF'
export const updateAuthBrandRefAction = (brandRef: FirebaseDocRefType) => {
  return {
    type: 'UPDATE_AUTH_BRAND_REF',
    payload: {
      brand_ref: brandRef,
    },
  }
}
